import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';
import { UserService } from '../services/user.service';
import { AuthService } from "../services/auth.service"; 
import { filter, delay } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { User } from '../models/user';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html'
})

export class NavMenuComponent {

    isExpanded = false;
    user = new User();
    userDetails;
    expirationDate: Date;
    isActivated = false;
    mySubscription: any;
    login = false;

    constructor( private router: Router, public translate: TranslateService, public userService: UserService, private authService: AuthService) {
        translate.addLangs(['es', 'en', 'pt', 'de']);
        translate.setDefaultLang('es');
        const browserLang = translate.getBrowserLang();
        translate.use(browserLang.match(/en|es|pr|de/) ? browserLang : 'es')
    }

    ngOnInit() {
        this.Login();
        this.mySubscription = this.userService.logginEvent.pipe(delay(500)).subscribe(() => {            
            this.Login();
        });
    }

    Login() {
        if (!this.authService.isTokenExpired()) {
            this.userService.getUser(this.authService.getLoginFromToken()).subscribe(x => { this.user = x; })
            this.userDetails = this.authService.getUserFromToken();
            this.login = true;
        }
        else {
            this.login = false;
        }
    }

    ngOnDestroy() {
        if (this.mySubscription) {
            this.mySubscription.unsubscribe();
        }
    }

    collapse() {
        this.isExpanded = false;
    }

    toggle() {
        this.isExpanded = !this.isExpanded;
    }

    public onLogout() {
        this.authService.removeToken();
        this.login = false;
        this.router.navigate(['/login']);
    }

}
